import { db } from '../../firebase';

// xross interface
import { XROSS_SERVICE_STATE } from '../interface';
// コレクション名定義
import { CL_STATUS } from '../define';

//
// サービスステータス を取得する
//
export const getXrossServiceStatus = async () => {
  console.log('getXrossServiceStatus>> called');
  const docid = '0';
  try {
    const snapshot = await db.collection(CL_STATUS).doc(docid).get();
    const status = snapshot.data() as XROSS_SERVICE_STATE;
    status.id = docid;
    console.log('status = ', status);
    return status;
  } catch (err) {
    console.log('getXrossServiceStatus>> ', err);
    return null;
  }
};

//
// メンテナンスモードにする
//
export const setOutOfService = async (isOutOfService: boolean) => {
  console.log('setOutOfService ', isOutOfService);
  const docid = '0';
  try {
    await db.collection(CL_STATUS).doc(docid).update({
      isOutOfService,
    });
  } catch (err) {
    console.log('setOutOfService>> ', err);
    return null;
  }
};

//
// メニュー表示・非表示を更新する
//
export const setMenuEnabled = async (params: {
  premiumMenu?: boolean;
  campaignMenu?: boolean;
}) => {
  console.log('setMenuEnabled ', params);
  const docid = '0';

  // update対象がない場合は何もしない（事故防止）
  if (params.premiumMenu === undefined && params.campaignMenu === undefined) {
    console.log('setMenuEnabled: no params to update');
    return null;
  }

  try {
    const updateData: any = {};

    if (params.premiumMenu !== undefined) {
      updateData['appSettings.menuEnabled.premiumMenu'] = params.premiumMenu;
    }
    if (params.campaignMenu !== undefined) {
      updateData['appSettings.menuEnabled.campaignMenu'] = params.campaignMenu;
    }

    // 運用管理用（必要なら）
    updateData['appSettings.lastRefreshAt'] = Date.now();

    await db.collection(CL_STATUS).doc(docid).update(updateData);
  } catch (err) {
    console.log('setMenuEnabled>> ', err);
    return null;
  }
};
